import { Webinar } from "../../../../icons";
import MobileNavTab from "./MobileNavTab";

export default function WebinarButton({ isActive }) {
	return (
		<MobileNavTab to="/webinar_list/" label="وبینارها" icon={Webinar} isActive={isActive} />
	);
}
